// src/core/signalr.ts

import {
    HubConnection,
    HubConnectionBuilder,
    HubConnectionState,
    LogLevel
} from '@microsoft/signalr';

import { CONFIG } from '../config';

let connection: HubConnection | null = null;
let connectingPromise: Promise<HubConnection> | null = null;

export async function connectSignalR(): Promise<HubConnection> {

    // Đã connect
    if (
        connection &&
        connection.state === HubConnectionState.Connected
    ) {
        return connection;
    }

    // Đang connect -> dùng lại promise hiện tại
    if (connectingPromise) {
        return connectingPromise;
    }

    const token = localStorage.getItem('accessToken');

    if (!token) {
        throw new Error('Không tìm thấy accessToken');
    }

    connection = new HubConnectionBuilder()
        .withUrl(
            `${CONFIG.API_BASE_URL}/signalr-hubs/geeteksilver`,
            {
                accessTokenFactory: () =>
                    localStorage.getItem('accessToken') ?? ''
            }
        )
        .withAutomaticReconnect([0, 2000, 5000, 10000])
        .configureLogging(LogLevel.Information)
        .build();

    connection.onclose(error => {
        console.log('[SignalR] Disconnected', error);
    });

    connection.onreconnecting(error => {
        console.log('[SignalR] Reconnecting...', error);
    });

    connection.onreconnected(connectionId => {
        console.log('[SignalR] Reconnected:', connectionId);
    });

    connectingPromise = connection.start()
        .then(() => {
            console.log('[SignalR] Connected');
            return connection!;
        })
        .catch(error => {
            console.error('[SignalR] Connection failed:', error);

            connection = null;

            throw error;
        })
        .finally(() => {
            connectingPromise = null;
        });

    return connectingPromise;
}

export function getSignalR(): HubConnection | null {
    return connection;
}

export async function disconnectSignalR(): Promise<void> {

    if (!connection) {
        return;
    }

    try {
        await connection.stop();
    } finally {
        connection = null;
        connectingPromise = null;
    }
}